import React from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import FallbackIcon from '../fallback/index.svg';
import theme from '@/theme';

/**
 * Shown when the `humeoAppEnabled` feature flag is off. No buttons — nothing the user
 * can do will flip the flag back on, so we don't pretend otherwise. (Contrast with
 * `<Fallback>`, which is for recoverable render crashes and has retry actions.)
 */
const AppUnavailable: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      paddingY={7}
      paddingX={2}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      boxSizing="border-box"
      style={{ backgroundColor: theme.palette.common.white }}
    >
      <Box marginBottom={3}>
        <FallbackIcon />
      </Box>
      <Box marginBottom={1}>
        <Typography variant="subtitle1">{t('appUnavailable.title')}</Typography>
      </Box>
      <Box marginX={8}>
        <Typography align="center" variant="body2">
          {t('appUnavailable.info')}
        </Typography>
      </Box>
    </Box>
  );
};

export default AppUnavailable;
